import { render, staticRenderFns } from "./CopyrightAssignmentTransferDetails.vue?vue&type=template&id=4556cce4&scoped=true&"
import script from "./CopyrightAssignmentTransferDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferDetails.vue?vue&type=style&index=0&id=4556cce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4556cce4",
  null
  
)

export default component.exports